import { useRecoilState, useRecoilValue } from 'recoil';

import { AnimateLifecycle } from '../../Animate';
import { isPaletteOpenedSelector, openedPaletteAtom } from '../state';
import type { VisiblePalette } from '../types';
import { PaletteMenuRoot } from './PaletteMenu';
import { PaletteView } from './PaletteView';

export type PaletteProps = {
    /**
     * Use Spine Menu to display the palette.
     */
    useMenu?: boolean;
};

/**
 * Singleton component to render the current palette.
 */
export function Palette(props: PaletteProps) {
    const [visiblePalette, setVisiblePalette] = useRecoilState(openedPaletteAtom);

    if (props.useMenu && !visiblePalette?.palette.asGrid) {
        return (
            <PaletteMenuRoot
                visiblePalette={visiblePalette}
                onVisiblePaletteChange={setVisiblePalette}
            />
        );
    }

    return (
        <LegacyPaletteRoot
            visiblePalette={visiblePalette}
            onVisiblePaletteChange={setVisiblePalette}
        />
    );
}

function LegacyPaletteRoot(props: {
    visiblePalette: VisiblePalette | null;
    onVisiblePaletteChange: (visiblePalette: VisiblePalette | null) => void;
}) {
    const { visiblePalette, onVisiblePaletteChange } = props;
    return (
        <AnimateLifecycle>
            {visiblePalette ? (
                <PaletteView
                    paletteState={visiblePalette}
                    setPaletteState={onVisiblePaletteChange}
                />
            ) : null}
        </AnimateLifecycle>
    );
}

export function useIsPaletteOpened() {
    return useRecoilValue(isPaletteOpenedSelector);
}
